<template>
  <span>
    <v-chip
      dense
      small
      color="primary"
      v-for="permission of permisisonsArray"
      :key="permission"
      class="mx-2"
      >{{ permission }}</v-chip
    >
  </span>
</template>
<script>
export default {
  name: 'PermissionsTags',
  props: {
    permisisons: {
      type: String,
      required: true
    }
  },
  methods: {
    charToString(char) {
      switch (char) {
        case 'A':
          return 'Add'
        case 'C':
          return 'Create'
        case 'D':
          return 'Delete'
        case 'DV':
          return 'deleteVersion'
        case 'E':
          return 'Execute'
        case 'L':
          return 'List'
        case 'M':
          return 'Move'
        case 'R':
          return 'Read'
        case 'T':
          return 'Tag'
        case 'W':
          return 'Write'
        default:
          return `Unknown ${char}`
      }
    }
  },
  computed: {
    permisisonsArray() {
      return this.permisisons.split(',').map(char => {
        return this.charToString(char)
      })
    }
  }
}
</script>
